import React from 'react';
import { PiTrashDuotone } from 'react-icons/pi';
import { Button } from 'rizzui';
import { FilterOptions } from '../../../hooks/useFilters';

interface DepartmentsFiltersProps {
    updateFilters: (filters: any) => void
    resetFilters: (limit: any) => void
    filters: FilterOptions
}

const DepartmentsFilters: React.FC<DepartmentsFiltersProps> = ({ filters, updateFilters, resetFilters }) => {

    return (
        <>

            <Button
                size="sm"
                onClick={() => {
                    resetFilters(50);
                }}
                variant="flat"
                className="h-9 bg-gray-200/70"
            >
                <PiTrashDuotone className="me-1.5 h-[17px] w-[17px]" /> Limpiar
            </Button>
        </>
    );
};

export default DepartmentsFilters;